module.exports = __webpack_public_path__ + "static/media/pendingActive.6ee8f583.svg";